/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";

// @mui material components

// Argon Dashboard 2 PRO MUI components
import SequenceInfo from "0.Mine/0.Components/CRM/Sequence/Sequence";
import RuleBuilder from "0.Mine/0.Components/CRM/SequenceRules/RuleBuilder";
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI example components
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ComplexReportsDoughnutChart from "examples/Charts/DoughnutCharts/ComplexReportsDoughnutChart";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";
import complexReportsDoughnutChartData from "layouts/applications/analytics/data/complexReportsDoughnutChartData";

function CRMFlow() {
  return (
    <DashboardLayout>
      <BusinessNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          {/*<Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <ComplexStatisticsCard
                    image="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/reports1.jpg"
                    icon="account_circle"
                    count={{ number: 1600, label: "Messages" }}
                    percentage="+55%"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ComplexStatisticsCard
                    image="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/reports2.jpg"
                    icon="touch_app"
                    count={{ number: 357, label: "Unread Messages" }}
                    percentage="+124%"
                  //dropdown={{
                  //  action: openClickEventsMenu,
                  //  menu: renderMenu(clickEventsMenu, closeClickEventsMenu),
                  //}}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ComplexStatisticsCard
                    image="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/reports3.jpg"
                    icon="shopping_cart"
                    count={{ number: 2300, label: "Channels" }}
                    percentage="+55%"
                  //dropdown={{
                  //  action: openPurchasesMenu,
                  //  menu: renderMenu(purchasesMenu, closePurchasesMenu),
                  //}}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ComplexStatisticsCard
                    image="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/reports4.jpg"
                    icon="thumb_up"
                    count={{ number: 940, label: "Reactions" }}
                    percentage="+90%"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <ComplexReportsDoughnutChart
                title="Messages"
                chart={complexReportsDoughnutChartData}
                tooltip="See which websites are sending traffic to your website"
              />
            </Grid>
          </Grid>*/}
        </ArgonBox>
        <SequenceInfo />
        <RuleBuilder />
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CRMFlow;
